import { APP_CONFIG } from "../constants";

/** URL absoluta para arquivos públicos do backend (`/uploads/...`). */
export function publicUploadUrl(path: string): string {
  if (!path) return "";
  if (path.startsWith("http://") || path.startsWith("https://") || path.startsWith("data:")) {
    return path;
  }
  return `${APP_CONFIG.API_URL}${path}`;
}

/** URL absoluta para imagens de orientação de produção (`/uploads/...`). */
export function orientacaoProducaoImageUrl(path: string): string {
  return publicUploadUrl(path);
}
